var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-module"}},[_c('module-form',{attrs:{"moduleInfo":_vm.moduleInfo,"submit":_vm.createModule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }